import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { WithTimeoutInteractivityActionSnapshotOut } from './WithTimeoutInteractivityAction';

export const withTimeoutInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.WithTimeout,

  innerInteractivityActions: {
    fromSnapshot(sn: WithTimeoutInteractivityActionSnapshotOut) {
      return [sn.interactivityAction];
    },
  },
};
